import styled from 'styled-components';
import { MarkerIcon } from '@rsos/assets/icons';
import { Button, Box } from '@rsos/base-components';

const RequestButton = styled(Button).attrs({
  btnType: 'invisible',
  noMargin: true,
})`
  height: auto;
  padding: 4px 2px;
`;

interface RequestLocationProps {
  onSuccess: (url: string) => void;
}

const RequestLocation = ({ onSuccess }: RequestLocationProps) => {
  //
  const fetchUrl = () => {
    return onSuccess('actual link will go here when wired up');
  };
  return (
    <Box padding="8px 16px 16px">
      <RequestButton onClick={fetchUrl}>
        <MarkerIcon height={12} width={12} />
        Request Location
      </RequestButton>
    </Box>
  );
};

export default RequestLocation;
